import { useTranslation } from "react-i18next";
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/style.css";
//import { useNavigate } from "react-router-dom";

interface ProfileImageProps {
    imageUrl: string;
    riderId: string;
    showRiderId?: boolean;
    changeImage?: boolean;
}

const ProfileImage: React.FC<ProfileImageProps> = ({
                                                       imageUrl,
                                                       riderId,
                                                       showRiderId = true,
                                                       changeImage = false,
                                                   }) => {
    const { t } = useTranslation();
    //const navigate = useNavigate();

    return (
        <div className="flex items-center">
            <Gallery>
                <Item original={imageUrl} thumbnail={imageUrl}>
                    {({ ref, open }) => (
                        <img
                            ref={ref as React.MutableRefObject<HTMLImageElement>}
                            onClick={(e) => {
                                e.stopPropagation();
                                open(e);
                            }}
                            src={imageUrl}
                            alt="Profile"
                            style={{
                                display: "block",
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                flexShrink: 0,
                                cursor: "pointer",
                            }}
                        />
                    )}
                </Item>
            </Gallery>

            {showRiderId && (
                <p className="text-white text-small">
                    {t("Rider ID")}: {riderId}
                </p>
            )}
        </div>
    );
};

export default ProfileImage;
